import _ from 'lodash'

import { getAppConfig } from 'deploy-env/app-config'

export const AMLO_RIGHT_TYPE_CODE = 'AMLO RIGHT'
export const TAMLO_RIGHT_TYPE_CODE = 'TAMLO RIGHT'
export const AMLO_RIGHT_TYPE_CODES = [AMLO_RIGHT_TYPE_CODE, TAMLO_RIGHT_TYPE_CODE]
export const AMLO_APPLICABLE_AGENT_TYPES = ['AGENT', 'WS']

export const REASON = {
  AMLO: 'AMLO',
  NO_AMLO: 'NO_AMLO',
  TOGGLE_OFF: 'TOGGLE_OFF',
  MIDDLEWARE_OFF: 'MIDDLEWARE_OFF',
  OUT_OF_SCOPE: 'OUT_OF_SCOPE',
  ADVISOR_API_ERROR: 'ADVISOR_API_ERROR',
}

export const isAmloApplicable = (agentType) => AMLO_APPLICABLE_AGENT_TYPES.includes(agentType)

export const isCheckAmloEnabled = () => Boolean(_.get(getAppConfig(), 'CHECK_AMLO.isEnabled', false))

export const isAmloEnabledByMiddlewareConfig = (config) => Boolean(_.get(config, 'enableAmlo', true))

const hasActiveAmlo = (advisor) => {
  const registrations = _.get(advisor, 'party.registrations') || []
  return registrations.some((r) => r && AMLO_RIGHT_TYPE_CODES.includes(r.typeCode) && r.state === 'active')
}

export const evaluateAmloAccess = ({ advisor }) => {
  return hasActiveAmlo(advisor)
    ? { hasAccess: true, reason: REASON.AMLO }
    : { hasAccess: false, reason: REASON.NO_AMLO }
}
